import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconMembers = (props) => {
  props = Object.assign({viewBox: '0 0 36 36'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <path d="M12.3,14.9c2.3,0,4.3-1.9,4.3-4.3s-1.9-4.3-4.3-4.3s-4.3,1.9-4.3,4.3S10,14.9,12.3,14.9z M12.3,7.7c1.6,0,3,1.3,3,3
		s-1.3,3-3,3s-3-1.3-3-3S10.7,7.7,12.3,7.7z"/>
        <path d="M24,15.9c2.2,0,4.1-1.8,4.1-4.1S26.3,7.8,24,7.8c-2.2,0-4.1,1.8-4.1,4.1S21.8,15.9,24,15.9z M24,9c1.5,0,2.8,1.3,2.8,2.8
		c0,1.5-1.3,2.8-2.8,2.8c-1.5,0-2.8-1.3-2.8-2.8C21.2,10.3,22.5,9,24,9z"/>
        <path d="M24,17.3c-2,0-3.9,0.8-5.3,2.2c-0.1-0.1-0.2-0.3-0.3-0.4c-1-1.3-2.4-2.2-4-2.7l0,0c-1.4-0.4-2.7-0.4-4.1,0l0,0
		c-1.5,0.4-2.9,1.2-4,2.5c-1.2,1.4-1.9,3.3-1.9,5.1l0,1.3c0,2.4,0,3.6,0,3.7l0,0.6h5.7h4.3h5.1h0.4h11.3l0-0.6c0-0.2,0-4.2,0-4.2
		C31.5,20.6,28.2,17.3,24,17.3z M18.9,25.3c0,1.6,0,2.5,0,3h-4.3h-4.3H5.8c0-0.6,0-1.7,0-3l0-1.3c0-1.6,0.6-3.1,1.6-4.3
		c0.9-1,2-1.7,3.3-2.1h0c1.2-0.3,2.3-0.3,3.4,0h0c1.3,0.4,2.5,1.1,3.4,2.2c0.9,1.2,1.4,2.6,1.4,4.1L18.9,25.3z M30.2,28.3H20.2
		c0-0.5,0-1.4,0-3l0-1.3c0-1.2-0.3-2.3-0.8-3.3c1.2-1.3,2.8-2.1,4.6-2.1c3.4,0,6.2,2.8,6.2,6.2C30.2,25,30.2,27.2,30.2,28.3z"/>
        <path d="M10.6,24.4h6.1v-4.3h-6.1V24.4z M11.8,21.4h3.5v1.7h-3.5V21.4z"/>
        <path d="M22.7,25h5.1v-3.7h-5.1V25z M24,22.6h2.6v1.1H24V22.6z"/>
      </g>
    </SvgIcon>
  );
};
// IconMembers = pure(IconMembers);
IconMembers.displayName = 'IconMembers';
IconMembers.muiName = 'SvgIcon';

export default IconMembers;



// WEBPACK FOOTER //
// ./src/components/Icons/IconMembers.js